// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"b58f5e91","214":"b56dbfb5","945":"a239bdd1","985":"a239bdd1"}[chunkId] + ".chunk.css";
};